export const eddid_client_server_develop = "http://127.0.0.1:3001/"
export const eddid_client_server = "https://eddid-client-api.ntdev.be/eddid-client-api-feature"
export const eddid_idp_admin_api = "http://127.0.0.1:3000/"
